import {Box, Paper} from '@mui/material';
import React from 'react';
import {Link} from 'react-router-dom';

import {AccountBasicFragment_contacts} from '../../schema-types/AccountBasicFragment';

export const VulnerableClientBanner: React.FC<{
  contacts?:
    | Pick<
        AccountBasicFragment_contacts,
        'id' | 'simplifiedName' | 'isVulnerable' | 'curoId'
      >[]
    | null;
  genericMessage?: boolean;
}> = ({contacts, genericMessage = false}) => {
  if (genericMessage) {
    return (
      <Paper
        sx={{
          backgroundColor: 'secondary.main',
          color: 'white',
          marginBottom: '1rem',
          padding: '1rem',
        }}
      >
        <span>Vulnerable Client</span>
      </Paper>
    );
  }

  return (
    <>
      {contacts?.map((x) => {
        if (!x.isVulnerable) {
          return null;
        }

        return (
          <Paper
            key={x.id}
            sx={{
              backgroundColor: 'secondary.main',
              color: 'white',
              marginBottom: '1rem',
              padding: '1rem',
            }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="baseline">
              <span>Vulnerable Client - {x.simplifiedName}</span>
              <Link
                to={{
                  pathname: `/contacts/${x.curoId}/`, // contacts consumes curoId, not id ¯\_(ツ)_/¯
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{color: 'white'}}
              >
                More Details
              </Link>
            </Box>
          </Paper>
        );
      })}
    </>
  );
};
